export default __webpack_public_path__ + "static/media/Photographs3.fc94c996.png";